<style
  lang="less">
  .el-card {
    box-shadow: none !important;
  }

  .el-tabs--border-card {
    border: 1px solid #eaeaea !important;
    box-shadow: none !important;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 0 !important;
  }

  .product-container {
    float: left;
    margin-right:20px;
    #product {
      cursor: pointer;
      transition: all .2s linear;
      width: 275px;
      margin-bottom:20px;
      &:hover {
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        transform: translate3d(0, -5px, 0);
      }
      .image {
        overflow: hidden;
        display: block;
        height: 210px;
        width: 100%;
        padding: 5px;
      }

      a {
        color: #888 !important;
      }

      .summary {
        font-size: 13px;
        color: #aaa;
        height: 60px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .product-container:nth-of-type(4n){
    margin-right: 0!important;
  }

</style>

<template>
  <!--todo extract productList-->
  <div class="product-container">
    <el-card id="product"
             :body-style="{ padding: '0px' }"
    >
      <router-link :to="{ name: 'product-detail', params: { serialId: serialId }}">
        <img :src="img" class="image">
        <div style="padding: 14px;">
          <p style="font-size: 16px; color: #333;width: 240px;height: 40px;overflow: hidden;">{{ title }}</p>
          <p class="summary">{{ summary }}</p>
          <br>
          <p v-if="inReduceActivity({discountPrice: discountPrice})">价格：&nbsp;
            <span style="color: red;font-size: 16px">
              <s style="color: #999">&yen;{{ price | zero-price-filter }}</s>
              &yen;{{ price - discountPrice | zero-price-filter }}
            </span>
          </p>
          <p v-else>价格：&nbsp;<span style="color: red;font-size: 16px">&yen;{{ price | zero-price-filter }}</span></p>
        </div>
      </router-link>
    </el-card>
  </div>
</template>

<script>
  import z from '../utils'

  /**
   * 产品列表页 产品 item
   */
  export default {
    methods: {
      inReduceActivity: z.inReduceActivity
    },
    props: {
      title: String,
      summary: String,
      price: Number,
      img: String,
      serialId: String,
      discountPrice: {
        type: Number,
        default: 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?2fb9e457